import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-row-center-start fz-18 font-blod" }
const _hoisted_2 = { class: "color-primary" }
const _hoisted_3 = {
  key: 0,
  class: "font-blod co-0066FF"
}
const _hoisted_4 = {
  key: 1,
  class: "font-blod co-0066FF"
}

import { ref, getCurrentInstance, onMounted, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticalQuantity',
  props: {
	data: {
		type: Object,
		default: function () {
			return {}
		}
	}
},
  setup(__props, { expose: __expose }) {

const props = __props;

const { proxy } = getCurrentInstance() as any;
const details = ref({});

watch(() => props.data, () => {
	if (props.data.api) {
		proxy.$api.tokenRequest({
			url: props.data.api,
			data: props.data.data,
			success: (res: any) => {
				details.value = res.data;
			},
		});
	}
})

onMounted(() => {
	if (props.data.api) {
		proxy.$api.tokenRequest({
			url: props.data.api,
			data: props.data.data,
			success: (res: any) => {
				details.value = res.data;
			},
		});
	}
});

const RefreshCount = () => {
	if (props.data.api) {
		proxy.$api.tokenRequest({
			url: props.data.api,
			data: props.data.data,
			success: (res: any) => {
				details.value = res.data;
			},
		});
	}
};

__expose({
	RefreshCount,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.arr, (v, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex-row-center-start mr-80",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(v.name) + "：", 1),
        (__props.data.api)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(details.value[v.key]), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(v.key), 1))
      ]))
    }), 128))
  ]))
}
}

})